// extracted by mini-css-extract-plugin
export default {"tag-input--container":"TagInput_tag-input--container__KgEHv","tag-input--container__items":"TagInput_tag-input--container__items__105tp","tag--item":"TagInput_tag--item__H2vvr"};